// Öffnet das Rückruf-Fenster (CallbackModal) von überall auf der Seite.
export const OPEN_CALLBACK_EVENT = 'bd:open-callback';

export const openCallback = () => window.dispatchEvent(new Event(OPEN_CALLBACK_EVENT));
